/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Manual_SaveInputs */

const vi_einvoice_manual_save = /** @type {(inputs: Einvoice_Manual_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu`)
};

/**

* @param {Einvoice_Manual_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_manual_save = /** @type {((inputs?: Einvoice_Manual_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Manual_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_manual_save(inputs)
});